/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIStatusDaeEnum } from './APIStatusDaeEnum';
import {
    APIStatusDaeEnumFromJSON,
    APIStatusDaeEnumFromJSONTyped,
    APIStatusDaeEnumToJSON,
} from './APIStatusDaeEnum';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedSupplyOrderRequest
 */
export interface APIPatchedSupplyOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof APIPatchedSupplyOrderRequest
     */
    supplier?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedSupplyOrderRequest
     */
    article?: string;
    /**
     * 
     * @type {APIStatusDaeEnum}
     * @memberof APIPatchedSupplyOrderRequest
     */
    status?: APIStatusDaeEnum;
    /**
     * 
     * @type {Date}
     * @memberof APIPatchedSupplyOrderRequest
     */
    dueDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedSupplyOrderRequest
     */
    amount?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedSupplyOrderRequest
     */
    unit?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedSupplyOrderRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedSupplyOrderRequest
     */
    comment?: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIPatchedSupplyOrderRequest
     */
    approval?: boolean;
}



/**
 * Check if a given object implements the APIPatchedSupplyOrderRequest interface.
 */
export function instanceOfAPIPatchedSupplyOrderRequest(value: object): value is APIPatchedSupplyOrderRequest {
    return true;
}

export function APIPatchedSupplyOrderRequestFromJSON(json: any): APIPatchedSupplyOrderRequest {
    return APIPatchedSupplyOrderRequestFromJSONTyped(json, false);
}

export function APIPatchedSupplyOrderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedSupplyOrderRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'supplier': json['supplier'] == null ? undefined : json['supplier'],
        'article': json['article'] == null ? undefined : json['article'],
        'status': json['status'] == null ? undefined : APIStatusDaeEnumFromJSON(json['status']),
        'dueDate': json['due_date'] == null ? undefined : (new Date(json['due_date'])),
        'amount': json['amount'] == null ? undefined : json['amount'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'description': json['description'] == null ? undefined : json['description'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'approval': json['approval'] == null ? undefined : json['approval'],
    };
}

export function APIPatchedSupplyOrderRequestToJSON(value?: APIPatchedSupplyOrderRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'supplier': value['supplier'],
        'article': value['article'],
        'status': APIStatusDaeEnumToJSON(value['status']),
        'due_date': value['dueDate'] == null ? undefined : ((value['dueDate']).toISOString()),
        'amount': value['amount'],
        'unit': value['unit'],
        'description': value['description'],
        'comment': value['comment'],
        'approval': value['approval'],
    };
}

